import { SearchCollections_search_edges_node } from "@saleor/searches/types/SearchCollections";
import React from "react";
import { useIntl } from "react-intl";

import AssignContainerDialog, {
  AssignContainerDialogProps
} from "../AssignContainerDialog";

interface AssignCollectionDialogProps
  extends Omit<AssignContainerDialogProps, "containers" | "title" | "search"> {
  collections: SearchCollections_search_edges_node[];
}

const AssignCollectionDialog: React.FC<AssignCollectionDialogProps> = ({
  collections,
  ...rest
}) => {
  const intl = useIntl();

  return (
    <AssignContainerDialog
      containers={collections}
      search={{
        label: intl.formatMessage({
          defaultMessage: "Search Recommendation Groups"
        }),
        placeholder: intl.formatMessage({
          defaultMessage: "Search by recommendation groups name, etc..."
        })
      }}
      title={intl.formatMessage({
        defaultMessage: "Assign Recommendation Groups",
        description: "dialog header"
      })}
      {...rest}
    />
  );
};

AssignCollectionDialog.displayName = "AssignCollectionDialog";
export default AssignCollectionDialog;
